// JWT imports removed - no authentication required

const state = {
  user: null,
  isAuthenticated: false
}

const mutations = {
  SET_USER(state, user) {
    console.log('👤 SET_USER mutation:', { 
      previousUser: state.user?.email || 'none', 
      newUser: user?.email || 'none' 
    })
    state.user = user
  },
  // Token mutations removed - no authentication required
  SET_AUTHENTICATED(state, isAuthenticated) {
    console.log('🔐 SET_AUTHENTICATED mutation:', { 
      previous: state.isAuthenticated, 
      new: isAuthenticated 
    })
    state.isAuthenticated = isAuthenticated
  },
  LOGOUT(state) {
    console.log('🚪 LOGOUT mutation: Clearing all authentication data')
    state.user = null
    state.isAuthenticated = false
    
    // Clear localStorage
    localStorage.removeItem('user')
    
    console.log('🔒 User logged out')
  }
}

const actions = {
  // Login action removed - use registration only
  // async login({ commit }, token) { ... },

  // checkAuth action removed - no authentication required

  async logout({ commit }) {
    console.log('🚪 LOGOUT action: Starting logout process')
    commit('LOGOUT')
    console.log('✅ Logout completed')
  },

  // refreshToken action removed - no authentication required

  // Login success action removed - use registration only
  // async loginSuccess({ commit }, { token, user, refreshToken }) { ... },

  // Force logout without API call (for token expiration, etc.)
  forceLogout({ commit }) {
    console.log('🚨 FORCE_LOGOUT action: Force logout without API call')
    commit('LOGOUT')
    console.log('✅ Force logout completed')
  },

  // clearTokens action removed - no authentication required
}

const getters = {
  isAuthenticated: state => state.isAuthenticated,
  user: state => state.user
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 